module.exports = __webpack_public_path__ + "static/media/management.b261f5ca.png";